import React, { useState, useEffect } from "react";
import { Table, Button, Form } from "react-bootstrap";
import Api from "../../utils/Api";
import Notifier from "../../components/Notifier";

export default function DesktopConfiguration() {
    const [categories, setCategories] = useState([]);
    const [budgetLimits, setBudgetLimits] = useState({});
    const [editingCategory, setEditingCategory] = useState(null);
    const [tempAmount, setTempAmount] = useState("");
    const notifierRef = React.createRef();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const { response } = await Api.lookups();
            const { categories: categoriesData } = response;
            
            // Filter out categories that should be ignored (not part of balance)
            const relevantCategories = categoriesData.filter(cat => !cat.shouldBeIgnored);
            setCategories(relevantCategories);

            // Load budget limits
            const { response: limitsData } = await Api.getBudgetLimits();
            if (limitsData && limitsData.budgetLimits) {
                const limitsMap = {};
                limitsData.budgetLimits.forEach(limit => {
                    limitsMap[limit.categoryId] = limit.amount;
                });
                setBudgetLimits(limitsMap);
            }
        } catch (error) {
            console.error("Error loading data:", error);
            notifierRef?.current?.showError("שגיאה בטעינת נתונים");
        }
    };

    const handleEdit = (categoryId) => {
        setEditingCategory(categoryId);
        setTempAmount(budgetLimits[categoryId] || "");
    };

    const handleCancel = () => {
        setEditingCategory(null);
        setTempAmount("");
    };

    const handleSave = async (categoryId) => {
        const amount = parseFloat(tempAmount);
        
        if (tempAmount && (isNaN(amount) || amount <= 0)) {
            notifierRef?.current?.showError("הכנס סכום תקין");
            return;
        }

        try {
            const response = await Api.setBudgetLimit({
                categoryId,
                amount: tempAmount ? amount : null
            });

            if (response.status === 200) {
                setBudgetLimits(prev => ({
                    ...prev,
                    [categoryId]: tempAmount ? amount : undefined
                }));
                setEditingCategory(null);
                setTempAmount("");
                notifierRef?.current?.showSuccess("התקציב עודכן בהצלחה");
            } else {
                notifierRef?.current?.showError("שגיאה בעדכון התקציב");
            }
        } catch (error) {
            console.error("Error saving budget limit:", error);
            notifierRef?.current?.showError("שגיאה בעדכון התקציב");
        }
    };

    const cardStyle = {
        background: "white",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px",
        width: "60%",
        margin: "auto",
        marginTop: "10px",
        padding: "20px"
    };

    return (
        <div style={{ marginTop: "78px" }}>
            <h2 style={{ textAlign: "center", marginBottom: "30px" }}>הגדרות תקציב לפי קטגוריה</h2>
            <div style={cardStyle}>
                <Table dir="RTL" striped bordered hover>
                    <thead>
                        <tr>
                            <th style={{ width: "50px", textAlign: "center" }}>מזהה</th>
                            <th style={{ textAlign: "center" }}>קטגוריה</th>
                            <th style={{ width: "200px", textAlign: "center" }}>תקציב מקסימלי (₪)</th>
                            <th style={{ width: "150px", textAlign: "center" }}>פעולות</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map((category) => {
                            const isEditing = editingCategory === category.id;
                            const currentLimit = budgetLimits[category.id];

                            return (
                                <tr key={category.id}>
                                    <td style={{ textAlign: "center" }}>{category.id}</td>
                                    <td style={{ textAlign: "center" }}>{category.description}</td>
                                    <td style={{ textAlign: "center" }}>
                                        {isEditing ? (
                                            <Form.Control
                                                type="number"
                                                value={tempAmount}
                                                onChange={(e) => setTempAmount(e.target.value)}
                                                placeholder="הכנס סכום"
                                                min="0"
                                                step="0.01"
                                                style={{ textAlign: "center" }}
                                            />
                                        ) : (
                                            <span>
                                                {currentLimit ? `₪${currentLimit.toLocaleString()}` : "לא מוגדר"}
                                            </span>
                                        )}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                        {isEditing ? (
                                            <>
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    onClick={() => handleSave(category.id)}
                                                    style={{ marginLeft: "5px" }}
                                                >
                                                    שמור
                                                </Button>
                                                <Button
                                                    variant="secondary"
                                                    size="sm"
                                                    onClick={handleCancel}
                                                >
                                                    ביטול
                                                </Button>
                                            </>
                                        ) : (
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                onClick={() => handleEdit(category.id)}
                                            >
                                                {currentLimit ? "ערוך" : "הגדר תקציב"}
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
                <div style={{ marginTop: "20px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "5px" }}>
                    <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                        <strong>הערה:</strong> התקציב המקסימלי מוגדר לכל קטגוריה בנפרד. 
                        ניתן להגדיר תקציב חודשי מקסימלי לכל קטגוריה, או להשאיר ללא הגבלה.
                    </p>
                </div>
            </div>
            <Notifier ref={notifierRef} />
        </div>
    );
}
